import { motion, AnimatePresence } from "framer-motion";
import Timeline from "./Timeline";

const TrackingModal = ({ isOpen, onClose, order }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* BACKDROP */}
          <motion.div
            className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          >
            {/* MODAL */}
            <motion.div
              onClick={(e) => e.stopPropagation()} // prevent close
              className="w-full max-w-md bg-white rounded-2xl p-5 max-h-[80vh] overflow-y-auto shadow-xl scrollbar-thin"
              initial={{ scale: 0.95, opacity: 0, y: 20 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.95, opacity: 0, y: 20 }}
              transition={{ duration: 0.25 }}
            >
              {/* HEADER */}
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-semibold text-neonYellow">
                  Track Order
                </h2>

                <button
                  onClick={onClose}
                  className="text-gray-400 hover:text-gray-600 transition"
                >
                  ✕
                </button>
              </div>

              {/* TIMELINE */}
              <Timeline order={order} />
            </motion.div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default TrackingModal;
